module.exports = __webpack_public_path__ + "img/Abstract Design.b634a8d7.png";